import { Box, Typography } from '@mui/material';
import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Pagination } from '@/components';
import { calculatePaginatedRows } from '@/helpers/pagination';
import { useAccountingProviderLogs } from '@/hooks';

import { AccountingProviderLogTable } from '../AccountingProviderLogTable';

const LOGS_PAGE_LIMIT = 10;

export const AccountingProviderLogSection = () => {
    const { t } = useTranslation();
    const { logs: providerLogs, isLoading: isLogsLoading } =
        useAccountingProviderLogs();
    const [logsPage, setLogsPage] = useState(1);

    const paginatedLogs = useMemo(
        () => calculatePaginatedRows(logsPage, providerLogs, LOGS_PAGE_LIMIT),
        [logsPage, providerLogs],
    );

    const handleLogsPageChange = useCallback(
        (_, page: number) => setLogsPage(page),
        [],
    );

    return (
        <Box sx={{ mb: 4 }}>
            <Typography fontSize={14} fontWeight="bold" sx={{ mb: 2 }}>
                {t('Invoicing:events_logs:title')}
            </Typography>
            {isLogsLoading ? null : (
                <>
                    <AccountingProviderLogTable
                        logs={paginatedLogs}
                        emptyStateMessage={t(
                            'Invoicing:events_logs:empty_state',
                        )}
                    />
                    {providerLogs.length > 0 ? (
                        <Pagination
                            testID="AccountingProvidersPage-LogsPagination"
                            page={logsPage}
                            pageLimit={LOGS_PAGE_LIMIT}
                            recordsCount={providerLogs.length}
                            onChange={handleLogsPageChange}
                        />
                    ) : null}
                </>
            )}
        </Box>
    );
};

export default AccountingProviderLogSection;
